import type { TFunction } from 'i18next';
import type { CaseStatus } from './api';

export const statusLabel = (t: TFunction, s: string): string => t(`serviceDesk.status.${s}`, { defaultValue: s });
export const severityLabel = (t: TFunction, s: string): string => t(`serviceDesk.severity.${s}`, { defaultValue: s });
export const categoryLabel = (t: TFunction, s: string): string => t(`serviceDesk.category.${s}`, { defaultValue: s });
export const channelLabel = (t: TFunction, s: string): string => t(`serviceDesk.channel.${s}`, { defaultValue: s });

/** AntD tag colours; the label always carries the meaning too. */
export function statusColour(status: CaseStatus): string | undefined {
  switch (status) {
    case 'ESCALATED':
      return 'error';
    case 'WAITING_CUSTOMER':
      return 'warning';
    case 'RESOLVED':
    case 'CLOSED':
      return 'success';
    case 'IN_PROGRESS':
      return 'processing';
    default:
      return undefined;
  }
}

export function severityColour(severity: string): string | undefined {
  return severity === 'HIGH' ? 'error' : severity === 'MEDIUM' ? 'warning' : undefined;
}
